/// <reference path="../references.ts" />

import userPageDirectiveFactory from './user-page/user-page.drv';
import UsersService from './users.srv';

angular.module('users', ['core', 'common', 'ui.router', 'tickets', 'article', 'ngFileUpload'])
	.config(require('./user-page-routing'))
	.directive('userPage', userPageDirectiveFactory)
	.service('usersService', UsersService);
